import axiosInstance from './axiosInstance';

export interface BranchPurchaseBreakdown {
  branchId: number;
  branchName?: string;
  branchNameAr?: string;
  requestCount: number;
  purchaseOrderCount: number;
  invoiceCount: number;
  totalAmount: number;
}

export interface CustodyReportItem {
  custodyId: number;
  custodyNumber: string;
  holderEmployeeId?: number;
  holderEmployeeCode?: string;
  holderName?: string;
  holderNameAr?: string;
  custodyType?: string;
  currentBalance: number;
  initialAmount: number;
  totalRequests: number;
  totalPurchaseOrders: number;
  totalInvoices: number;
  totalAmount: number;
  branchesCovered: number;
  branches: BranchPurchaseBreakdown[];
}

export interface CustodyPurchasesReport {
  generatedAt: string;
  periodFrom: string;
  periodTo: string;
  viewAll: boolean;
  totalCustodies: number;
  totalRequests: number;
  totalPurchaseOrders: number;
  totalInvoices: number;
  totalAmount: number;
  custodies: CustodyReportItem[];
}

export interface MyCustodyOption {
  custodyId: number;
  custodyNumber: string;
  currentBalance: number;
  employeeName?: string;
  employeeNameAr?: string;
}

const BASE = '/CustodyPurchasesReport';

export interface CentralCustody {
  custodyId: number;
  custodyNumber: string;
  employeeCode?: string;
  employeeName?: string;
  employeeNameAr?: string;
}

export interface AssignableUser {
  userId: number;
  username: string;
  fullName?: string;
  fullNameAr?: string;
  employeeName?: string;
  employeeNameAr?: string;
}

export const custodyPurchasesReportService = {
  run(fromDate: string, toDate: string, custodyId?: number): Promise<CustodyPurchasesReport> {
    const params: Record<string, any> = { fromDate, toDate };
    if (custodyId) params.custodyId = custodyId;
    return axiosInstance.get(`${BASE}/run`, { params }).then(r => r.data);
  },
  myCustodies(): Promise<{ viewAll: boolean; custodies: MyCustodyOption[] }> {
    return axiosInstance.get(`${BASE}/my-custodies`).then(r => r.data);
  },
  centralCustodies(): Promise<CentralCustody[]> {
    return axiosInstance.get(`${BASE}/central-custodies`).then(r => r.data);
  },
  assignableUsers(): Promise<AssignableUser[]> {
    return axiosInstance.get(`${BASE}/assignable-users`).then(r => r.data);
  },
  getKeeperAccess(userId: number): Promise<number[]> {
    return axiosInstance.get(`${BASE}/keeper-access/${userId}`).then(r => r.data);
  },
  saveKeeperAccess(userId: number, custodyIds: number[]): Promise<any> {
    return axiosInstance.post(`${BASE}/keeper-access`, { userId, custodyIds }).then(r => r.data);
  },
};

export default custodyPurchasesReportService;
